import { render, staticRenderFns } from "./PerfilPaciente.vue?vue&type=template&id=34299f16&scoped=true&"
import script from "./PerfilPaciente.vue?vue&type=script&lang=js&"
export * from "./PerfilPaciente.vue?vue&type=script&lang=js&"
import style0 from "./PerfilPaciente.vue?vue&type=style&index=0&id=34299f16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34299f16",
  null
  
)

export default component.exports